import { createFileRoute } from "@tanstack/react-router"
import { CreatePlanDialog } from "../-components/create-plan-dialog"

export const Route = createFileRoute("/_layout/planning/new/forecast")({
  component: () => <CreatePlanDialog source="forecast" />,
})
